import React from 'react';
import { Box, Typography } from '@mui/material';

export const getSessionCode = (sessionUUID: string, treatmentUUID: string): string => {
  const combined = sessionUUID + treatmentUUID;
  let hash = 0;

  for (let i = 0; i < combined.length; i++) {
    const char = combined.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }

  const positiveHash = Math.abs(hash) >>> 0;
  return positiveHash.toString(36).padStart(6, '0').substring(0, 6);
};

export const hashCurrentSession = (sessionUUID: string, treatmentUUID: string, className: string) => {
  const shortHash = getSessionCode(sessionUUID, treatmentUUID);

  return (
    <Box className={className}>
      <Typography className={`${className}-code`}>{shortHash}</Typography>
    </Box>
  );
};
